import { Handle, Position } from '@xyflow/react';
import { Building2 } from 'lucide-react';
import type { OrganizationNodeData } from '../utils/buildOrganigramLayout';

export function OrganizationNode({ data }: { data: OrganizationNodeData }) {
  const getLogoUrl = (): string | undefined => {
    if (!data.logo) return undefined;
    if (data.logo.type === 'svg') {
      return data.logo.svg;
    }
    return data.logo.thumbnail?.webp || data.logo.thumbnail?.png;
  };

  const logoUrl = getLogoUrl();

  const renderLogo = () => {
    if (!logoUrl) {
      return (
        <div className="h-12 w-12 rounded-lg bg-info-surface flex items-center justify-center">
          <Building2 className="w-6 h-6 text-info" />
        </div>
      );
    }

    return (
      <>
        <img
          src={logoUrl}
          alt={data.name || 'Organization'}
          className="h-12 w-12 rounded-lg object-contain"
          onError={(e) => {
            // Hide broken image and show fallback
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }}
        />
        <div className="h-12 w-12 rounded-lg bg-info-surface flex items-center justify-center hidden">
          <Building2 className="w-6 h-6 text-info" />
        </div>
      </>
    );
  };

  return (
    <div className="bg-white border border-line rounded-lg shadow-xs hover:border-line-strong hover:shadow-md transition-all w-[280px]">
      <div className="px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="shrink-0">{renderLogo()}</div>
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-base text-foreground truncate">
              {data.name || 'Organization'}
            </div>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="w-2 h-2 bg-fill-neutral!" />
    </div>
  );
}
